<div class="pos-absolute z-2 _container  pe-none"
     [style.top.%]="data.top_position || 0"
     [style.left.%]="data.left_position || 0"
     [style.right.%]="data.right_position || 0">
    <!-- lines -->
    @for (line of data.lines; track $index) {
    @switch (line.type) {
    <!-- text -->
    @case ('text') {
    <span class="w-12"
          [style.color]="line.color"
          [ngClass]="[line.align || '',line.padding_top || '', line.text_style || 'h4', line.style || '', line.shadow ? '_text-shadow' : '']"
          [style.font-size.px]="line.text_size"
          [style.line-height.px]="line.text_size"
          [style.letter-spacing.px]="line.text_letter_spacing"
          [style.margin-left.px]="line.text_letter_spacing && line.align === 'center' ? line.text_letter_spacing / 2 : ''"
          *iCms="'text' of line; tag: line.tag"></span>
    }
    <!-- button -->
    @case ('button') {
    <div [ngClass]="[line.align || '', line.padding_top || '']"
         class="_custom-button pe-none"
         [style.--scale]="line.button_scale">
         <href class="pe-auto" [link]="line.button_link">
            <div [ngClass]="[line.button_class || '', line.shadow && buttonShadow(line.button_class) || '']"
                 [style.min-width.px]="line.button_width || 0"
                 [style.--color]="line.color || ''"
                 [class._custom-color]="line?.button_class?.includes('button-inline') && line.color" >
                <span class="button__body"
                    *iCms="'text' of line"></span>
            </div>
        </href>
    </div>
    }
    }
    }

</div>